// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__110Vw","item":"PaymentsMobile_item__1bxNR","label":"PaymentsMobile_label__3A5zO","amount":"PaymentsMobile_amount__1xU8n"};